(function () {
  window.BCCartUi = {
    initProgressBars: initProgressBars,
    initShippingBadges: initShippingBadges
  };

  function initProgressBars(root) {
    root.querySelectorAll('[data-bc-progress]').forEach(function (bar) {
      var value = parseFloat(bar.getAttribute('data-bc-progress') || '0');
      if (isNaN(value)) value = 0;
      value = Math.max(0, Math.min(100, value));
      bar.style.width = value + '%';
    });
  }

  function initShippingBadges(root) {
    var badges = root.querySelectorAll('[data-bc-ship-badge]');
    if (!badges.length) return;

    // ===== DEBUG - TOGLIERE DOPO I TEST =====
    //  ?debug_now=2026-06-14T23:50  -> simula data/ora in ORA ITALIANA (anche solo YYYY-MM-DD)
    //  ?debug_estero=1 / 0          -> forza consegna estero / italia
    var QS = new URLSearchParams(location.search);
    var DEBUG_NOW = QS.get('debug_now');
    var DEBUG_ESTERO = QS.get('debug_estero');
    // ===== FINE DEBUG =====

    var TZ = 'Europe/Rome';

    function initBadge(badge) {
      var el = badge.querySelector('[data-bc-ship-timer]');
      var arrivoEl = badge.querySelector('[data-bc-ship-arrivo]');
      if (!el) return;

      var CUTOFF_HOUR = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var CARRIER_HOLIDAYS = parseHolidayList(el.getAttribute('data-carrier-holidays') || el.getAttribute('data-holidays') || '');
      var COMPANY_HOLIDAYS = parseHolidayList(el.getAttribute('data-company-holidays') || '');
      var ESTERO = el.getAttribute('data-estero') === 'true';
      if (DEBUG_ESTERO === '1') ESTERO = true;   // DEBUG - TOGLIERE
      if (DEBUG_ESTERO === '0') ESTERO = false;   // DEBUG - TOGLIERE
      var ESTERO_MIN = parseInt(el.getAttribute('data-estero-min'), 10) || 3;
      var ESTERO_MAX = parseInt(el.getAttribute('data-estero-max'), 10) || 5;

      // Lingua del widget: inglese all'estero, italiano in Italia
      var L = ESTERO ? {
        wd: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        mo: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        today: 'today', tomorrow: 'tomorrow', dayAfter: 'the day after tomorrow',
        hourS: 'hour', hourP: 'hours', minU: 'min',
        order: function (left, when) { return 'Order within <strong>' + left + '</strong> and we ship <strong>' + when + '</strong>'; },
        delivery: function (a, b) { return 'Estimated delivery in <strong>' + a + '-' + b + ' working days</strong>, courier delays excluded.'; }
      } : {
        wd: ['domenica', 'lunedi', 'martedi', 'mercoledi', 'giovedi', 'venerdi', 'sabato'],
        mo: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
        today: 'oggi', tomorrow: 'domani', dayAfter: 'dopodomani',
        hourS: 'ora', hourP: 'ore', minU: 'min',
        order: function (left, when) { return 'Ordina entro <strong>' + left + '</strong> e spediamo <strong>' + when + '</strong>'; },
        delivery: function (a, b) { return 'Consegna stimata tra <strong>' + a + '</strong> e <strong>' + b + '</strong>, salvo ritardi del corriere.'; }
      };

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function ymd(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }

      // "Adesso" in ora italiana, indipendente dal fuso del visitatore.
      function romeNow() {
        // DEBUG - TOGLIERE: usa la data/ora simulata dall'URL come fosse ora italiana.
        if (DEBUG_NOW) {
          var dm = DEBUG_NOW.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
          if (dm) {
            return { y: +dm[1], m: +dm[2], d: +dm[3], H: +(dm[4] || 0), Mi: +(dm[5] || 0), S: +(dm[6] || 0) };
          }
        }

        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        });
        var p = {};
        f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        return { y: +p.year, m: +p.month, d: +p.day, H: +p.hour, Mi: +p.minute, S: +p.second };
      }

      // Epoch (ms) di un orario "da calendario" italiano, robusto al cambio ora legale.
      function romeWallToEpoch(y, mo, d, h, mi, s) {
        var guess = Date.UTC(y, mo - 1, d, h, mi, s || 0);
        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        });
        var o = {};
        f.formatToParts(new Date(guess)).forEach(function (x) { o[x.type] = x.value; });
        var hh = o.hour === '24' ? 0 : +o.hour;
        var asWall = Date.UTC(+o.year, +o.month - 1, +o.day, hh, +o.minute, +o.second);
        return guess - (asWall - guess);
      }

      // Giorno della settimana a prova di fuso (0=dom .. 6=sab).
      function weekday(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12)).getUTCDay(); }

      function parseHolidayList(value) {
        return String(value || '').split(',').map(function (date) { return date.trim(); }).filter(function (date) { return date; });
      }

      function isCarrierBiz(y, m, d) {
        var w = weekday(y, m, d);
        if (w === 0 || w === 6) return false;
        return CARRIER_HOLIDAYS.indexOf(ymd(y, m, d)) === -1;
      }

      function isShippingBiz(y, m, d) {
        return isCarrierBiz(y, m, d) && COMPANY_HOLIDAYS.indexOf(ymd(y, m, d)) === -1;
      }

      // Primo giorno di partenza DOPO la data indicata.
      function nextShippingBiz(y, m, d) {
        var dt = new Date(Date.UTC(y, m - 1, d, 12));
        do {
          dt.setUTCDate(dt.getUTCDate() + 1);
        } while (!isShippingBiz(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate()));
        return dt;
      }

      function fmtDate(dt) {
        return L.wd[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + L.mo[dt.getUTCMonth()];
      }

      function todayUTC(n) { return new Date(Date.UTC(n.y, n.m - 1, n.d, 12)); }

      function addCarrierBiz(dt, k) {
        var d = new Date(dt.getTime());
        var c = 0;
        while (c < k) {
          d.setUTCDate(d.getUTCDate() + 1);
          if (isCarrierBiz(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate())) c++;
        }
        return d;
      }

      function relDay(target, base) {
        var diff = Math.round((target.getTime() - base.getTime()) / 86400000);
        if (diff <= 0) return L.today;
        if (diff === 1) return L.tomorrow;
        if (diff === 2) return L.dayAfter;
        return fmtDate(target);
      }

      function fmtLeft(secs) {
        var tot = Math.ceil(secs / 60);
        var h = Math.floor(tot / 60);
        var m = tot % 60;
        var hLabel = h === 1 ? L.hourS : L.hourP;
        if (h > 0 && m > 0) return h + ' ' + hLabel + ' ' + m + ' ' + L.minU;
        if (h > 0) return h + ' ' + hLabel;
        return m + ' ' + L.minU;
      }

      function render() {
        var n = romeNow();
        var sod = n.H * 3600 + n.Mi * 60 + n.S;
        var cutoff = CUTOFF_HOUR * 3600;
        var today = todayUTC(n);
        var shipsToday = isShippingBiz(n.y, n.m, n.d) && sod < cutoff;
        var shipDate = shipsToday ? today : nextShippingBiz(n.y, n.m, n.d);
        var diffToShip = Math.round((shipDate.getTime() - today.getTime()) / 86400000);

        if (diffToShip <= 1) {
          var nowEpoch = romeWallToEpoch(n.y, n.m, n.d, n.H, n.Mi, n.S);
          var shipEpoch = romeWallToEpoch(shipDate.getUTCFullYear(), shipDate.getUTCMonth() + 1, shipDate.getUTCDate(), CUTOFF_HOUR, 0, 0);
          var remaining = Math.round((shipEpoch - nowEpoch) / 1000);
          var when = diffToShip === 0 ? L.today : L.tomorrow;
          el.style.display = '';
          el.innerHTML = L.order(fmtLeft(remaining), when);
        } else {
          el.style.display = 'none';
        }

        if (arrivoEl) {

          if (ESTERO) {
            arrivoEl.innerHTML = L.delivery(ESTERO_MIN, ESTERO_MAX);
          } else {
            var arrLow = addCarrierBiz(shipDate, 1);
            var arrHigh = addCarrierBiz(shipDate, 2);
            arrivoEl.innerHTML = L.delivery(relDay(arrLow, today), relDay(arrHigh, today));
          }
        }

        if (DEBUG_NOW) return;
        setTimeout(render, 60000);
      }

      render();
    }

    badges.forEach(initBadge);
  }
})();
